import { CalendarBold } from '@ha/icons';
import React, { useState, useEffect } from 'react';
import dayjs from 'dayjs';
import { makeStyles, Theme } from '@material-ui/core';
import { useSelector } from 'react-redux';

import { useIntl } from 'ha/i18n';
import { useMediaQuery } from 'ha/helpers/MediaQuery';
import { AlertLabs, Link, units } from '@ha/dsl';
import { useCookie } from 'ha/pages/Search/hooks/useCookie';
import { getDateFilterValue } from 'ha/pages/Search/selectors/filterSelectors';

const useStyles = makeStyles((theme: Theme) => ({
  container: {
    marginBottom: units.rem(1),
  },
  icon: {
    color: theme.palette.grey[600],
  },
}));

export const SearchResultsNotificationToAddDatesOnFilter: React.FC = () => {
  const { T } = useIntl();
  const { md } = useMediaQuery();
  const classes = useStyles();

  const [cookie, updateCookie] = useCookie('use_dates_filter');
  const { startDate, endDate } = useSelector(getDateFilterValue);

  const [isOpen, setIsOpen] = useState(false);

  useEffect(() => {
    if (cookie) {
      setIsOpen(false);
      return;
    }

    if (!startDate) {
      setIsOpen(true);
      return;
    }

    setIsOpen(false);
  }, [cookie, startDate, endDate]);

  const handleOnClose = React.useCallback(() => {
    updateCookie('accepted', {
      expires: dayjs().add(1, 'day').toDate(),
    });

    setIsOpen(false);
  }, [updateCookie]);

  const handleOnClick = React.useCallback(
    (e: React.MouseEvent) => {
      e.preventDefault();
      const anchor = document.getElementById('date-filter');

      if (md) {
        anchor?.scrollIntoView({
          behavior: 'smooth',
          block: 'center',
          inline: 'end',
        });
      }

      setTimeout(() => {
        anchor?.click();
      }, 500);

      handleOnClose();
    },
    [handleOnClose, md],
  );

  if (isOpen) {
    return (
      <AlertLabs
        icon={md ? <CalendarBold className={classes.icon} /> : false}
        severity="notification"
        onClose={handleOnClose}
        className={classes.container}
      >
        <Link to="" kind="mint-underline" onClick={handleOnClick}>
          {T('search.info_bar.add_dates_link')}
        </Link>
        {` ${T('search.info_bar.add_dates_why')}`}
      </AlertLabs>
    );
  }

  return null;
};

export default SearchResultsNotificationToAddDatesOnFilter;
